import workshopScene from "@/assets/workshop-scene.jpg";
const About = () => {
  return <section id="historie" aria-labelledby="about-heading" className="section-padding bg-cream">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div className="relative order-2 lg:order-1">
            <div className="aspect-[3/4] overflow-hidden">
              <img src={workshopScene} alt="Bunadstuggu verksted med symaskin og tråd" className="w-full h-full object-cover object-center" />
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <p className="text-primary font-sans text-xs tracking-[0.3em] uppercase mb-4">
              Vår historie
            </p>
            <h2 id="about-heading" className="font-serif text-3xl md:text-4xl lg:text-5xl text-foreground mb-8 leading-tight">
              Historie
            </h2>
            <div className="space-y-5 text-muted-foreground font-sans leading-relaxed">
              <p>
                Røros Husflidutsalg ble etablert av Iver Tønseth i 1934, senere tok 
                Helge Tønseth over. For ca 60 år siden begynte Husfliden Røros å selge 
                Grafferdrakten, og noen år senere kom også Lundebybunaden.
              </p>
              <p>
                I 1997 tok Lena Tønseth over Husfliden, men i 2003 solgte hun firmaet 
                og flyttet til Trondheim. Dit tok hun med seg bunadene som en del av 
                arven, og da startet Bunadstuggu. Den 1. februar 2012 flyttet Bunadstuggu 
                til Levanger, der Grete og Rolf Drågen tok over bedriften.
              </p>
              <p>
                Januar 2018 tok Solbjørg og Hans Arne Drågen over bedriften, da Grete 
                og Rolf sluttet da Grete ble pensjonist. Vi gleder oss til å fortsette 
                og produsere Grafferdrakten og Lundebybunaden, og vi skal gjøre vårt 
                beste for at nye og gamle kunder skal bli fornøyd.
              </p>
              <p className="text-foreground font-medium">
                Vi er opptatt av å bringe gode bunadstradisjoner videre. Alle våre bunader 
                er norskprodusert, og vi bruker kun norske materialer. Alle bunader blir 
                tilpasset hver enkelt kunde.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default About;